import React, { Component } from "react";
//import PageTitleBar from "Components/PageTitleBar/PageTitleBar";
//import IntlMessages from "Util/IntlMessages";
//import RctCollapsibleCard from "Components/RctCollapsibleCard/RctCollapsibleCard";
import RctSectionLoader from "./../RctSectionLoader/RctSectionLoader";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Button from "@material-ui/core/Button";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from "reactstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { TableRow } from "@material-ui/core";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import {  contactmasterexcelfileuploadcall,getContactMasterReq } from "../../../../apiservicescall/api";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import DateFnsUtils from "@date-io/date-fns";
import SelectSearch, { fuzzySearch } from "react-select-search";
import IconButton from "@material-ui/core/IconButton";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Excelpage2 from "./Excelpage2";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import { blue, grey, yellow } from "@material-ui/core/colors";

export default class Excelpage1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvfile: null,
      addNewUserModal: false, 
      loading: true, 
      reload: false, 
      autoReopenModal: false, 
    };
  }

  componentDidMount = () => {
    // console.log(this.props);
    let reRender = this.props.reRender;
  }

  opnAddNewUserModal(e) {
    this.setState({
      addNewUserModal: true,
      autoReopenModal: false, 
    });
  }

 


  onChangeExcel = (event) => {
    this.setState({ csvfile: event.target.files[0] });
  };


  handleSubmit = async () => { 
    this.setState({ reload: true });
    let data = new FormData();
    data.append("file", this.state.csvfile);

    if (this.state.csvfile) {
      try {
        let reqforupload = await contactmasterexcelfileuploadcall(data);
        if (reqforupload?.status === 200) {
          NotificationManager.success(reqforupload?.data || "Uploaded");
          this.setState({
            csvfile: null,
            reload: false,
            addNewUserModal: false, 
          });
          this.props.reRender();
        } else {
          NotificationManager.warning("Invalid Data Format", reqforupload?.statusText);
          this.setState({ csvfile: null, reload: false });
        }
      } catch (error) {
        NotificationManager.error("Error during upload", error?.message);
        this.setState({ csvfile: null, reload: false });
      }
    } else {
      NotificationManager.error("File Not found");
      this.setState({ reload: false });
    }
    console.log('data', data)
    
  }

  onAddUpdateUserModalClose() { 
    console.log('Closing modal, current state:', this.state.autoReopenModal);
    if (this.state.autoReopenModal) {
        this.setState({
            addNewUserModal: true,
            autoReopenModal: false,
        });
    } else {
      console.log("Closing modal, state before closing:", this.state);
      this.setState({ addNewUserModal: false, autoReopenModal: false });
    }
}


  render() {
    const { addNewUserModal, csvfile, loading,reload } = this.state;
    const { customerType, parentCallback } = this.props;

    return (
      <>
        <Tooltip title={"upload excel file"}>
          <IconButton>
            <CloudUploadIcon
              onClick={(e) => this.opnAddNewUserModal(e)}
            // onClick={handleOpen}
            />
          </IconButton>
        </Tooltip>

        <Modal
          isOpen={this.state.addNewUserModal}
          toggle={this.onAddUpdateUserModalClose}
        >

          <ModalHeader
          //  toggle={() => this.onAddUpdateUserModalClose()}
           >
            {"Upload"}
          </ModalHeader>


          <ModalBody>
          {reload === true && <RctSectionLoader />}
            <Excelpage2
              csvfile={this.state.csvfile}
              onChangeExcel={this.onChangeExcel}
            />
          </ModalBody>

          <ModalFooter>
          {reload === false && (
            <Button
              variant="contained"
              color="primary"
              disabled={!this.state.csvfile}
              style={{marginRight:"10px"}}
              className="text-white"
              onClick={() => this.handleSubmit()}
            >
              UPLOAD
            </Button>
             )}
            
            <Button
              variant="contained"
              className="text-white btn-danger"
              onClick={() => this.onAddUpdateUserModalClose()}
            >
              Cancel
            </Button>
          </ModalFooter>
         
        </Modal>
      </>
    );
  }
}